export function validate_fields(refs)
{
    let fieldCheck = true,
        fieldError = '',
        formCheck = true

    refs.forEach(ref => {

        if(ref.optional && ref.value == '') return
        if(ref.value == undefined)
        {
            fieldCheck = false
            return
        }

        switch (ref.type) {
            case 'discountCode':
                fieldCheck = ((ref.value).length !== 16) ? false : true
                fieldError = 'codice buono non valido'
            break;

            case 'address':
                fieldCheck = ((ref.value).length < 4) ? false : true
                fieldError = 'questo indirizzo non è valido'
            break;
            
            case 'city':
                fieldCheck = ((ref.value).length < 3 | !(/^[a-zA-Z 'àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð]+$/.test(ref.value))) ? false : true
                fieldError = 'questa città non è valida'
            break;
            
            case 'postalCode':
                fieldCheck = ((ref.value).length !== 5) ? false : true
                fieldError = 'il CAP non è valido'
            break;
            
            case 'province':
                fieldCheck = ((ref.value).length !== 2) ? false : true
                fieldError = 'la sigla della provincia deve essere formata da due lettere'
            break;

            case 'fiscalCode':
                fieldCheck = ((ref.value).length !== 16) ? false : true
                fieldError = 'completa o verifica la correttezza del codice'
            break;

            case 'email':
                fieldCheck = (/\S+@\S+\.\S+/.test(ref.value)) ? true : false
                fieldError = 'questo indirizzo email non è valido'
            break;

            case 'emailtobeconfirmed':
                fieldCheck = (/\S+@\S+\.\S+/.test(ref.value)) ? true : false
                fieldError = 'questo indirizzo email non è valido'
            break;

            case 'emailconfirm':
            case 'emailConfirm':
                fieldCheck = ref.value == ref.email
                fieldError = 'la mail di conferma è diversa da quella inserita'
            break;

            case 'firstname':
            case 'firstName':
                fieldCheck = ((ref.value).length < 2) ? false : true
                fieldError = 'il nome deve essere composto da almeno due caratteri'
            break;

            case 'lastname':
            case 'lastName':
                fieldCheck = ((ref.value).length < 2) ? false : true
                fieldError = 'il cognome deve essere composto da almeno due caratteri'
            break;

            case 'phone':
                fieldCheck = ((ref.value).length < 4) ? false : true
                fieldError = 'numero di telefono non valido'
            break;

            case 'checkbox':
                fieldCheck = (ref.value == true)
                fieldError = 'questo campo è obbligatorio'
            break;

            case 'textarea':
                fieldCheck = ((ref.value).length < 4) ? false : true
                fieldError = 'questo campo non può essere vuoto'
            break;

            default:
                fieldCheck = false
                fieldError = ''
            break;
        }
        
        if(ref.ref !== undefined)
        {
            if(fieldCheck)
            {
                ref.ref.$el.classList.remove('invalid')
                fieldError = ''
            }
            else
            {
                if(ref.value !== '') ref.ref.$el.classList.add('invalid')
            }
            if(ref.ref.$el.nextSibling && ref.ref.$el.nextSibling.classList.contains('formerror'))
            {
                if(ref.value !== '') ref.ref.$el.nextSibling.innerHTML = fieldError
            }
        }
        formCheck = formCheck && fieldCheck
    });

    return formCheck
}